// Shared ApexCharts option builders so per-metric charts stay concise
// while keeping the ZIMTA visual language consistent.

export const BRAND_GREEN = '#0C5935';
export const BRAND_RED = '#cf2e2e';
export const BRAND_GOLD = '#c79a2c';
export const BRAND_SAND = '#a87445';

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const baseGrid = {
  borderColor: 'rgba(0,0,0,0.08)',
  strokeDashArray: 3,
  padding: { left: 0, right: 16, top: 10, bottom: 0 }
};

const baseLabelStyle = { colors: '#6b6b6b', fontSize: '12px' };

export const areaOptions = ({ categories, color = BRAND_GREEN, yFormatter }) => ({
  chart: {
    type: 'area',
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: 'inherit',
    animations: { easing: 'easeinout', speed: 600 }
  },
  colors: [color],
  dataLabels: { enabled: false },
  stroke: { curve: 'smooth', width: 2.5 },
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.5,
      opacityTo: 0.02,
      stops: [0, 100],
      colorStops: [
        { offset: 0, color, opacity: 0.5 },
        { offset: 100, color, opacity: 0.02 }
      ]
    }
  },
  grid: baseGrid,
  xaxis: {
    categories,
    labels: { style: baseLabelStyle },
    axisBorder: { show: false },
    axisTicks: { show: false }
  },
  yaxis: {
    labels: {
      style: baseLabelStyle,
      formatter: yFormatter
    }
  },
  tooltip: { theme: 'light', style: { fontSize: '13px' } }
});

export const barOptions = ({
  categories,
  colors = [BRAND_GREEN],
  yFormatter,
  horizontal = false
}) => ({
  chart: {
    type: 'bar',
    toolbar: { show: false },
    fontFamily: 'inherit',
    animations: { easing: 'easeinout', speed: 600 }
  },
  colors,
  dataLabels: { enabled: false },
  plotOptions: {
    bar: { horizontal, borderRadius: 4, columnWidth: '55%' }
  },
  grid: baseGrid,
  xaxis: {
    categories,
    labels: { style: baseLabelStyle },
    axisBorder: { show: false },
    axisTicks: { show: false }
  },
  yaxis: { labels: { style: baseLabelStyle, formatter: yFormatter } },
  tooltip: { theme: 'light', style: { fontSize: '13px' } },
  legend: { labels: { colors: '#6b6b6b' } }
});

export const lineOptions = ({ categories, colors = [BRAND_GREEN], yFormatter }) => ({
  chart: {
    type: 'line',
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: 'inherit',
    animations: { easing: 'easeinout', speed: 600 }
  },
  colors,
  dataLabels: { enabled: false },
  stroke: { curve: 'smooth', width: 3 },
  markers: { size: 4, strokeWidth: 0 },
  grid: baseGrid,
  xaxis: {
    categories,
    labels: { style: baseLabelStyle },
    axisBorder: { show: false },
    axisTicks: { show: false }
  },
  yaxis: { labels: { style: baseLabelStyle, formatter: yFormatter } },
  tooltip: { theme: 'light', style: { fontSize: '13px' } },
  legend: { labels: { colors: '#6b6b6b' } }
});

export const donutOptions = ({
  labels,
  colors = [BRAND_GREEN, BRAND_GOLD, BRAND_SAND, BRAND_RED]
}) => ({
  chart: { type: 'donut', fontFamily: 'inherit' },
  labels,
  colors,
  stroke: { width: 0 },
  dataLabels: { enabled: false },
  legend: { position: 'bottom', labels: { colors: '#6b6b6b' } },
  plotOptions: {
    pie: {
      donut: {
        size: '68%',
        labels: {
          show: true,
          total: { show: true, label: 'Total', color: '#6b6b6b' }
        }
      }
    }
  },
  tooltip: { theme: 'light' }
});
